import styled, { css, keyframes } from 'styled-components';

export const Container = styled.div`
  display: flex;
  position: absolute;
  top: -47px;
  width:48px;
  height: var(--size-large);
  background-color: #e6e6e6;
  border-radius: 30px;
  transition: 0.4s;
  margin-bottom: var(--size-small);
  text-align: center;
  z-index: 2;

  @media (max-width: 576px) {
    top: 10px !important;
    position: relative !important;
    margin-top: var(--size-medium);
  }
`;

export const sliderAnim = keyframes`
  0% {
    transform: translateX(1px);
  }
  100% {
    transform: translateX(23.5px);
  }
`;

export const sliderAnimBack = keyframes`
   0% {
        transform: translateX(23.5px);
    }
    100% {
        transform: translateX(1px);
    }
`;

export const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--disabled);
  border-radius: 34px;
  transition: 0.5s;
  &:before {
    position: absolute;
    content: "";
    height: 17.8px;
    width: 17.8px;
    left: 3px;
    bottom: 1.8px;
    background-color: var(--font-color);
    border-radius: 50%;
    transition: 0.5s;
    animation: ${({ checked }: { checked: boolean }) =>
        checked ? css`${sliderAnim} 0.5s forwards` : css`${sliderAnimBack} 0.3s forwards`}; 
  }
  @media (max-width: 1269px) {
        &:before {
            bottom: 2px;
            height: 20px;
            width: 20px;
            left: 1.7px;
        }
  }
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + ${Slider} {
    background: linear-gradient( 90deg, var(--secondary-dark), var(--primary-light))
  }

  &:checked + ${Slider}:before {
    transform: translateX(24px);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`
const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`

export const LabelOn = styled.label<{
  checked: boolean
}>`
  position: absolute;
  top: 50%;
  left: 55px;
  transform: translateY(-50%);
  align-items: center;
  justify-content: center;
  font-size: var(--size-medium);
  min-height: 20px;
  color: var(--font-color);
  font-weight: var(--font-weight-semi-bold);
  transition: all 0.5s ease;
  white-space: nowrap;
  display: flex;
  animation: ${ props => (props.checked ? css`${fadeIn} 0.3s cubic-bezier(0.70, 0.00, 1, 1) forwards` : css`${fadeOut} 0.3s cubic-bezier(0.00, 0.70, 1, 1) forwards`)};
`;

export const LabelOff = styled.label<{
    checked: boolean
}>`
  position: absolute;
  top: 50%;
  left: 55px;
  transform: translateY(-50%);
  align-items: center;
  justify-content: center;
  font-size: var(--size-medium);
  min-height: 20px;
  color: var(--font-color);
  font-weight: var(--font-weight-semi-bold);
  transition: all 0.5s ease;
  white-space: nowrap;
  display: flex;
  animation: ${props => (props.checked ? css`${fadeOut} 0.3s cubic-bezier(0.00, 0.70, 1, 1) forwards` : css`${fadeIn} 0.3s cubic-bezier(0.70, 0.00, 1, 1) forwards`)};
`;



export const LabelInfo = styled.div`
    display:flex;
    width: 100vh;
`;